// extracted by mini-css-extract-plugin
export default {"tags":"styles_tags__MtqQE","tabs":"styles_tabs__9CFod","section-data-lists":"styles_section-data-lists__JqGg-","contacts-tabs":"styles_contacts-tabs__swsu4"};